import { events } from "aws-amplify/data";
import { generateClient } from "aws-amplify/api";
import { get_current_user } from "@/graphql/queries";
import { parseApiJson } from "@/utils/parseApiJson";
import { isPortalUnderMaintenance } from "@/utils/portalMaintenance";
import getPortalMaintenanceEventsConfig from "@/Configurations/portalMaintenanceEvents";

let channel = null;
let subscription = null;
let connecting = false;

function isTruthyFlag(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

function readMaintenanceFlag(data) {
  const candidates = [
    data,
    data?.event,
    data?.payload,
    data?.event?.payload,
  ];

  for (const candidate of candidates) {
    if (candidate == null) continue;

    let parsed = candidate;
    if (typeof candidate === "string") {
      parsed = parseApiJson(candidate, null);
    }
    if (!parsed || typeof parsed !== "object") continue;

    if ("portal_under_maintenance" in parsed) {
      return isTruthyFlag(parsed.portal_under_maintenance);
    }
  }

  return false;
}

async function refreshCurrentUserForMaintenance(store, router) {
  const client = generateClient();
  const response = await client.graphql({
    query: get_current_user,
  });
  const responseData = parseApiJson(response.data.get_current_user, {});
  if (responseData.status !== "SUCCESS") return;

  const userData = responseData.data[0] || {};
  const currentUser = store?.state?.currentUser || {};
  const nextUser = { ...currentUser, ...userData };
  store.dispatch("setCurrentUser", nextUser);

  if (
    isPortalUnderMaintenance(nextUser) &&
    router?.currentRoute?.value?.name !== "PortalMaintenance"
  ) {
    router.replace({ name: "PortalMaintenance" });
  }
}

export async function startPortalMaintenanceSubscription({ store, router } = {}) {
  const config = getPortalMaintenanceEventsConfig();
  if (!config?.endpoint || !config?.apiKey) return;
  if (channel || connecting) return;

  connecting = true;
  try {
    const channelName = String(config.channel || "portal-maintenance")
      .trim()
      .replace(/^\/+/, "");

    channel = await events.connect(channelName, { authMode: "apiKey" });
    subscription = channel.subscribe({
      next: async (data) => {
        if (!readMaintenanceFlag(data)) return;
        try {
          await refreshCurrentUserForMaintenance(store, router);
        } catch (error) {
          console.error(
            "[Portal Maintenance] get_current_user after event failed:",
            error
          );
        }
      },
      error: (error) => {
        console.error("[Portal Maintenance] subscription error:", error);
      },
    });
  } catch (error) {
    console.error("[Portal Maintenance] Events connect failed:", error);
    channel = null;
    subscription = null;
  } finally {
    connecting = false;
  }
}

export function stopPortalMaintenanceSubscription() {
  try {
    subscription?.unsubscribe?.();
  } catch (error) {
    /* ignore */
  }
  try {
    channel?.close?.();
  } catch (error) {
    /* ignore */
  }
  subscription = null;
  channel = null;
  connecting = false;
}
